import { breakpoints } from './breakpoints';

export default function scrollTo() {
  const doNotScroll = ['#subscribe'];

  /**
   * Do scroll
   */
  function doScroll(selector, delay = 0) {
    const $target = $(selector);

    let scrollTop = $target.offset().top;

    if ($target.is('.wp-block-columns')) {
      scrollTop -= 40;
    }

    if ($(window).width() < breakpoints.lg) {
      scrollTop -= $('.site-header').height();
    }

    setTimeout(function () {
      $([document.documentElement, document.body]).animate(
        {
          scrollTop,
        },
        1000,
        function () {
          $target
            .find('input[type="text"]:visible, input[type="email"]:visible')
            .first()
            .focus();
        }
      );
    }, delay);
  }

  /**
   * Clicking on link
   */
  $(document).on('click', 'a[href*="#"]', function (e) {
    if (
      $(this).attr('href') === '#' ||
      $(this).hasClass('no-scroll') ||
      doNotScroll.includes($(this).attr('href'))
    ) {
      return true;
    }
    const selector = `#${$(this).attr('href').split('#')[1]}`;

    if ($(selector).length) {
      e.preventDefault();
      doScroll(selector);
    }
  });

  /**
   * Scroll to element on page load
   */
  if (window.location.hash) {
    setTimeout(function () {
      window.scrollTo(0, 0);
    }, 1);
    doScroll(window.location.hash, 500);
  }
}
